import { useAuth } from '@/lib/config/auth-provider'

/**
 * Org kill switch for twin chat (`chatRoomsEnabled`).
 * Missing means on, matching the registry default.
 */
export function useTwinChatEnabled(): boolean {
  const { user } = useAuth()
  return user?.featureFlags?.chatRoomsEnabled !== false
}
